<template>
  <div id="app">
    <NavBar />
    <div id="app-content">
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
      <Footer />
    </div>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

export default {
  components: {
    NavBar,
    Footer
  }
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
p {
  font-size: 14px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(var(--vs-text));
  background: rgba(var(--vs-background), 1);
}
#app-content {
  padding-top: 93px;
  overflow: hidden;
}
.heading {
  margin-bottom: 2em;
}
.air {
  line-height: 1.4em;
}
.img img {
  width: 100%;
}
.wrapper {
  width: 90%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 2em 0;
}
.wrapper.s-pad {
  padding: 1em 0;
}
.wrapper.fill-vh {
  min-height: calc(100vh - 93px);
  margin-bottom: 3em;
}
a {
  text-decoration: none;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.slide-enter {
  transform: translateX(-30%);
}
.slide-leave-to {
  transform: translateX(30%);
}
.inputs {
  max-width: 75%;
  margin: 1.9em auto 1.5em auto;
  text-align: left;
}
.input {
  margin-bottom: 2em;
}
</style>
